export const unwrapRobloxFieldValue = (value: unknown): unknown => {
  if (value && typeof value === 'object' && value !== null && 'Value' in value) {
    return (value as { Value: unknown }).Value;
  }

  return value;
};

export const normalizeRobloxRowRecord = (
  record: IRecord = {},
): IRecord => {
  return Object.entries(record).reduce<IRecord>((acc, [key, value]) => {
    acc[key] = unwrapRobloxFieldValue(value);
    return acc;
  }, {});
};
